<template>
  <div>

    <div class="flex-column">
      <div class="contact-detail-header px-1 py-2">
        <div class="d-flex">
          <el-select @change="swContactList()" v-model="selectedSortStatus" size="mini"
                     class="w-150px">
            <el-option v-for="sort in sortStatus" :key="sort.val" :label="sort.name"
                       :value="sort.val"></el-option>
          </el-select>
          <el-input @input="searchByName" placeholder="Tìm kiếm..." class="w-200px contact-input mx-2"
                    size="mini"
                    v-model="searchKey"></el-input>
          <div class="flex-1" />

        </div>
      </div>
      <div class="divider-custom" />
      <div class="contact-item-list flex-1">
        <div v-for="contact in swContactView" :key="contact.id">
          <div class="bg-white">
            <div class="contact-item py-2 px-3">
              <el-avatar :size="52" :src="getAvatar(contact)"></el-avatar>
              <div class="flex-1 mx-3">
                <div class="d-flex">
                  <div class="font-size-16 text-1-line">{{ contact.name }}</div>
                  <div class="d-flex mx-1">
                    <div v-for="(item,index) in contact.tags" :key="index">
                      <TagCustom :item="item" :selected="false" :isButton="true" size="mini" />
                    </div>
                  </div>
                </div>
                <div class="d-flex " v-if="(isAdminUser()|| app.showPhoneInContact)">
                  <div class="font-size-16 text-1-line">SĐT:<span class="text-info">{{ contact.phone }}</span>
                  </div>
                </div>
                <div v-if="!contact.uid">
                  <div class="text-danger fw-semibold" v-if="contact.checkUid">{{ contact.log }}</div>
                  <div v-else>
                    <div class="text-danger">Đang chờ xử lý</div>
                  </div>
                </div>
                <div class="font-size-14" v-if="contact.createBy">Người tạo : {{contact.createBy}}</div>
              </div>
            </div>
            <div class="divider-custom" />
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center  mt-2">
      <el-pagination
        v-if="pageInfo.total > 1"
        background
        layout="prev, pager, next"
        :current-page="pageInfo.page"
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        @current-change="currentSwPageChanged"
        @prev-click="pageInfo.page -= 1"
        @next-click="pageInfo.page += 1"
      ></el-pagination>

    </div>
  </div>
</template>

<script>
import { syncReadFile } from "../../lib/file";
import TagCustom from "../common/TagCustom";

var FileSaver = require("file-saver");
export default {
  name: "ContactListSw",
  components: { TagCustom },
  props: ["selectedAccount"],
  watch: {
    selectedAccount: function() {
      this.getSwContact();
    }
  },
  data() {
    return {
      pageInfo: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      selectedSortType: "az",
      searchKey: "",
      sortType: [{ name: "Tên (A-Z)", val: "az" }, { name: "Tên (Z-A)", val: "za" }],
      sortStatus: [
        { name: "Tất cả danh bạ", val: "all" },
        { name: "Chưa xử lý", val: "pending" },
        { name: "Đã xử lý", val: "success" },
        { name: "Lỗi", val: "error" }
      ],
      selectedSortStatus: "all",
      swContacts: [],
      showAddListPhone: false,
      txtPhone: "",
      phoneNumbers: [],
      contents: [{ content: "" }],
      fileExample: ["0919283919\n", "0912345672\n", "0372718283\n"],
      addFr: false,
      swContactView: []
    };
  },

  methods: {
    getTag(id) {
      return this.app.tags.filter((t) => t.id == id)[0];
    },
    checkTag(id) {
      let s = this.app.tags.filter((t) => t.id == id);
      if (s != null && s.length > 0) {
        return true;
      }
      return false;
    },
    _syncReadFile(file, callback) {
      return syncReadFile(file, callback);
    },
    currentSwPageChanged(newPage) {
      this.pageInfo.page = newPage;
      this.swContactList();
    },
    upload() {
      this.$refs.fileUpload.click();
    },
    getAvatar(contact) {
      if (contact.avatar) {
        return contact.avatar;
      } else {
        return "/assets/images/no-avatar.png";
      }
    },
    addPhone(phone) {
      try {
        if (phone.trim().length === 0) return;
        if (phone.startsWith("+84")) {
          phone = "0" + phone.substring(3);
        } else if (phone.startsWith("84")) {
          phone = "0" + phone.substring(2);
        }
        const VN_PHONE_REGEX = /(84|0[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})\b/g;
        let res = phone.match(VN_PHONE_REGEX).map(function(s) {
          return s.trim();
        });
        res.forEach(s => {
          let index = this.phoneNumbers.indexOf(s);
          if (index < 0) {
            this.phoneNumbers.push(s);
          }

        });
      } catch (_) {
        //
      }
    },


    save() {
      let isEmpty = false;
      if (this.contents.length == 0) {
        isEmpty = true;
      } else {
        this.contents.forEach((it) => {
          if (it.content.length == 0) {
            isEmpty = true;
          }
        });
      }
      if (isEmpty && this.addFr) {
        this.alert("error", "Nội dung tin nhắn không được để trống.");
        return;
      }
      let body = {
        accountId: this.selectedAccount,
        phones: this.phoneNumbers.map(p => {
          return p;
        }),
        addFr: this.addFr,
        contents: this.contents.map(p => {
          return p.content;
        })
      };
      this.$http.post("/api/contact/addSwContact", body).then(() => {
        this.alert("success", "Thêm liên hệ thành công.");
        this.filter(true);
      });
      this.close();
    },
    close() {
      this.showAddListPhone = false;
    },
    deletePhone(phone) {
      let index = this.phoneNumbers.indexOf(phone);
      if (index > -1) {
        this.phoneNumbers.splice(index, 1);
      }
    },
    deleteContent(index) {
      this.contents.splice(index, 1);
    },
    downloadTxt() {
      var file = new File(this.fileExample, "file mau.txt", { type: "text/plain;charset=utf-8" });
      FileSaver.saveAs(file);
    },
    swContactList() {

      let view = this.swContacts;
      if (this.searchKey) {
        view = view.filter((c) => c.phone.includes(this.searchKey.toLowerCase()) || (c.name != null && c.name.toLowerCase().includes(this.searchKey.toLowerCase())));
      }
      if (this.selectedSortStatus == "pending") {
        view = view.filter((c) => !c.checkUid);
      }
      if (this.selectedSortStatus == "success") {
        view = view.filter((c) => c.checkUid);
      }
      if (this.selectedSortStatus == "error") {
        view = view.filter((c) => c.checkUid && !c.uid);
      }
      this.pageInfo.total = view.length;
      if (this.selectedType == "sw-contact") {
        this.swContacts.sort((a, b) => Number(b.checkUid) - Number(a.checkUid));
      }
      this.swContactView = view.slice((this.pageInfo.page - 1) * this.pageInfo.pageSize, this.pageInfo.page * this.pageInfo.pageSize);
      this.swContactView.forEach((contact) => {
        contact.tags = this.getTagByIds(contact.tagIds);
      });
    },
    getTagByIds(tagIds) {
      let items = [];
      if (tagIds != null && tagIds.length > 0) {
        let arr = tagIds.split(",");
        arr.forEach((id) => {
          let s = items.filter((i) => i.id == id);
          if (s != null && s.length == 0) {
            let tag = this.app.tags.filter(t => t.id == id);
            if (tag != null && tag.length > 0) {
              items.push(tag[0]);
            }
          }
        });
      }
      return items;
    },
    searchByName() {
      this.pageInfo.page = 1;
      this.swContactList();
    },
    addPhonePopup() {
      this.phoneNumbers = [];
      this.txtPhone = "";
      this.showAddListPhone = true;
    },
    addContent() {
      this.contents.push({ content: "" });
    },
    addPhoneN(phone) {
      if (phone.trim().length === 0) return;
      if (phone.startsWith("+84")) {
        phone = "0" + phone.substring(3);
      } else if (phone.startsWith("84")) {
        phone = "0" + phone.substring(2);
      }
      const VN_PHONE_REGEX = /(84|0[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})\b/g;
      let res = phone.match(VN_PHONE_REGEX);
      res.forEach(s => {
        let index = this.phoneNumbers.indexOf(s);
        if (index < 0) {
          this.phoneNumbers.push(s);
        }

      });
      this.txtPhone = "";
    },
    onChange() {
      let fileUpload = this.$refs.fileUpload.files[0];
      this._syncReadFile(fileUpload, text => {
        text.replaceAll("\r\n", "");
        let phoneNew = text.split("\n");
        phoneNew.forEach((p) => {
          this.addPhone(p.trim());
        });
      });
    },
    getSwContact() {
      this.$http
        .get("/api/contact/swContact", {
          params: {
            accountId: this.selectedAccount
          }
        })
        .then(resp => {
          this.swContacts = resp.data;
          this.app.contactTotal.swContact = this.swContacts.length;
          this.swContactList();
        });
    }
  },
  created() {
    if (this.selectedAccount)
      this.getSwContact();
  }
};
</script>

<style scoped>

</style>
